module.exports = __webpack_public_path__ + "img/legal_court_justice_lawyer_18x12.38f3df0a.png";